import $ from 'jquery';

/**
 * Validate the visible student fields
 */
class StudentFieldValidation {
    constructor () {
        this.$registerSubmit = $('.js-register-submit');

        this.$studentAcknowledge = $('.js-student-checkbox');
        this.$studentGraduationDate = $('.js-student-graduation-date');

        // Button Events
        this.$registerSubmit.on('click', $.proxy(this.submitClick, this));
    }

    submitClick () {
        let acknowledgeCheck = true;
        let graduationCheck = true;

        let $error;

        // Check Student Fields
        if (this.$studentAcknowledge.length) {
            // Check for concessionary acknowledgement
            if (this.$studentAcknowledge.is(':visible')) {
                // Check to see whether the opt-out has been selected
                acknowledgeCheck = this.$studentAcknowledge.find('input').is(':checked');

                if (!acknowledgeCheck) {
                    $error = $('<p class="u-warning">Please acknowledge that you will be required to provide proof of your eligibility for a concessionary membership rate.</p>');

                    if (!this.$studentAcknowledge.find('.warning').length) {
                        this.$studentAcknowledge.append($error);
                    }

                    alert('Please acknowledge that you will be required to provide proof of your eligibility for a concessionary membership rate.');
                }
            } else {
                acknowledgeCheck = true;
            }

            // Check for graduation date
            if (this.$studentGraduationDate.is(':visible')) {
                if (this.$studentGraduationDate.find('input').val()) {
                    graduationCheck = true;
                } else {
                    graduationCheck = false;
                }

                if (!graduationCheck) {
                    $error = $('<p class="u-warning">Please enter your expected graduation date.</p>');

                    if (!this.$studentGraduationDate.find('.warning').length) {
                        this.$studentGraduationDate.append($error);
                    }

                    alert('Please enter your expected graduation date.');
                }
            } else {
                graduationCheck = true;
            }
        }

        // Have all checks passed?
        return acknowledgeCheck && graduationCheck;
    }
}

export default StudentFieldValidation;
